import React from "react";
import { Routes, Route } from "react-router-dom";

import Home from './pages/Home';
import Writing from './pages/Writing';

function App() {
  return (
      <div className="App" style={{ width: "100%", height: "100%"}}>
        <Routes>
          <Route index element={<Home />} />
          <Route path="/writing" element={<Writing />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </div>
  );
}
export default App;